import React from 'react';
import { css } from '@emotion/react';
import { Link } from 'gatsby';

// Import assets directly at the top of the file from your local folder
import majorImg from '../images/O4-major.png';
import ltColImg from '../images/O5-lieutenant-colonel.png';
import colImg from '../images/O6-colonel.png';
import brigGenImg from '../images/O7-Brigadier-General.png';

// Map the ranks to the imported assets
const rankImages = {
  'Major': majorImg,
  'Lieutenant Colonel': ltColImg,
  'Colonel': colImg,
  'Brigadier General': brigGenImg,
};

const BioCard = ({ bio }) => {
  const cardName = `${bio.firstName} ${bio.middleName} ${bio.lastName}`;
  const currentRankImage = rankImages[bio.rank];

  return (
    <li className='tablet:grid-col-4 usa-card'>
      <div className='usa-card__container'>
        <header className='usa-card__header'>
          <h2 className='margin-y-0'>{cardName}</h2>
          <div className='grid-row flex-justify'>
            <div className='grid-col'>
              <p className='text-gray-30 margin-y-0'>{bio.rank}</p>
              <p className='text-gray-30 margin-y-0'>{`${bio.yearBorn} - ${bio.yearDied}`}</p>
            </div>
            <div
              className='grid-col'
              css={css`
                text-align: right;
              `}
            >
              {/* Uses your original height property format instead of inline style objects */}
              {currentRankImage && (
                <img src={currentRankImage} alt={bio.rank} height={45} />
              )}
            </div>
          </div>
        </header>
        <div className='usa-card__body'>
          <p>{`${bio.snippet} ...`}</p>
        </div>
        <div className='usa-card__footer'>
          <Link to={bio.link} className='usa-button'>
            Learn More
          </Link>
        </div>
      </div>
    </li>
  );
};

export default BioCard;
